export const GET_FAVORITE_SUCCESS = 'GET_FAVORITE_SUCCESS';
export const UPDATE_VIDEO_IN_FAVORITE_LIST = 'UPDATE_VIDEO_IN_FAVORITE_LIST';
export const LOADING_MESSAGE = '请稍等...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
